module.exports = __webpack_public_path__ + "img/full7-min.1a967926.png";